export class TipoAtto {
  id: string;
  rimosso: boolean;
  descrizione: string;
  label: string;
  isPct?: boolean;
}
